import { render, staticRenderFns } from "./CardFair.vue?vue&type=template&id=70a9c534&scoped=true"
import script from "./CardFair.vue?vue&type=script&lang=js"
export * from "./CardFair.vue?vue&type=script&lang=js"
import style0 from "./CardFair.vue?vue&type=style&index=0&id=70a9c534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9c534",
  null
  
)

export default component.exports